// extracted by mini-css-extract-plugin
export default {"terms":"GraphInfo_terms__yvrsF"};